import { createAsyncThunk } from '@reduxjs/toolkit'
import DomesticSearchService from './services/DomesticSearchPreviewService'

export const getDomesticSearchDetail = createAsyncThunk(
  'domesticSearch/GET_DOMESTIC_SEARCH_DETAIL',
  async (data, { rejectWithValue }) => {
    try {
      const response = await DomesticSearchService.getDomesticSearchDetail(data)
      if (response.success) {
        return response.data
      }

      return rejectWithValue('Error')
    } catch (error) {
      return rejectWithValue(error?.response?.status)
    }
  },
)
